import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TResetAuthorArticles, EResetAuthorArticlesActionType } from './types';

export const resetAuthorArticles: () => TResetAuthorArticles = actionGenerator<EResetAuthorArticlesActionType.Reset>(
  EResetAuthorArticlesActionType.Reset,
);
